import { useState, useEffect } from "react";

import { Input } from "@newsela/angelou";

import { useConceptTaxonomyProvider } from "@/search/Langston/ConceptTaxonomyProvider";
import {
  searchContainerCss,
  searchFormContainerCss,
  searchLabelCss,
} from "./SearchTags.styles";

interface ISearchTagsProps {
  onSearch: (query: string) => void;
}

export const SearchTags = ({ onSearch }: ISearchTagsProps) => {
  const { isTabletOrMobileView } = useConceptTaxonomyProvider();
  const [input, setInput] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(input);
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [input]);

  useEffect(() => {
    onSearch(debouncedQuery);
  }, [debouncedQuery]);

  return (
    <form css={searchFormContainerCss(isTabletOrMobileView)}>
      <Input
        label="Search Tags"
        inputType={Input.inputTypes.text}
        name="searchTags"
        onChange={(e) => setInput(e.target.value)}
        value={input}
        placeholder="Search"
        underInputId="search-tags-field"
        __cssFor={{
          root: searchContainerCss,
          label: searchLabelCss,
        }}
        dataProps={{
          "data-qa-selector": "search-taxonomy-modal",
          "data-testid": "search-taxonomy-modal",
        }}
      />
    </form>
  );
};
